module.exports = __webpack_public_path__ + "assets/images/officeBuilding-01.7fc39000dd3170b0c9bc8e557a1f6482.svg";